import Marquee from "@quarkly/community-kit/Marquee";
export default Marquee;